import React from 'react'
import {
  ButtonPrimary,
  CardContent,
  colors2,
  LoaderOverlay,
  MetaBlock,
  Modal,
  SkeletonLoader,
  TextInput,
  UI_BODY_DF,
  UI_DISPLAY,
  WrapperCardGrid,
} from "oolib";
import { useCreateReport, useGetAllReports } from "../ReportLanding/queries";
import { useNavigate } from "react-router-dom";
import { Fragment, useState } from "react";

const CreateModal = ({ setShowCreateModal, createReport, navigate }) => {
  const [title_subtitle, setTitleSubtitle] = useState({
    title: "",
    subtitle: "",
  });

  return (
    <Modal
      onClose={() => setShowCreateModal(false)}
    >
      <div
        style={{
          padding: "1.6rem",
          display: "flex",
          flexDirection: "column",
          gap: "1.2rem",
        }}
      >
        <TextInput
          isRequired={true}
          label="Title"
          onChange={(k, v) =>
            setTitleSubtitle((prev) => ({ ...prev, title: v }))
          }
          value={title_subtitle.title}
        />
        <TextInput
          label="Subtitle"
          onChange={(k, v) =>
            setTitleSubtitle((prev) => ({ ...prev, subtitle: v }))
          }
          value={title_subtitle.subtitle}
        />
        <ButtonPrimary
          disabled={!title_subtitle.title}
          onClick={() => {
            createReport(
              {
                type: "customDashboard",
                title: title_subtitle.title,
                subtitle: title_subtitle.subtitle,
              },
              {
                onSuccess: (res) => {
                  navigate(`/reports/edit/${res.data._id}`);
                },
              }
            );
          }}
        >
          Create Report
        </ButtonPrimary>
      </div>
    </Modal>
  );
};

export const ReportsListing = () => {
  const { data, status } = useGetAllReports();
  const navigate = useNavigate();
  const { mutate: createReport, isLoading } = useCreateReport();
  const [showCreateModal, setShowCreateModal] = useState(false);
  return (
    <Fragment>
        {isLoading && <LoaderOverlay loaderText='Creating Report...'/>}
      {showCreateModal && (
        <CreateModal
          setShowCreateModal={setShowCreateModal}
          createReport={createReport}
          navigate={navigate}
        />
      )}
      <div style={{ padding: "1.6rem" }}>
        <WrapperCardGrid>
          {status === "loading" ? (
            [1, 2, 4, 5, 6, 7, 8].map((d) => (
              <SkeletonLoader
                style={{ height: "30rem", borderRadius: "4px" }}
              />
            ))
          ) : (
            <Fragment>
              <button
                style={{
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  border: `1px solid ${colors2.grey30}`,
                  background: colors2.grey5,
                  minHeight: '30rem',
                  height: '100%',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setShowCreateModal(true);
                }}
              >
                <UI_BODY_DF>{"Create a New Report"}</UI_BODY_DF>
              </button>
              {data.map((d) => (
                <CardContent
                  data={d}
                  onClick={() => navigate(`/reports/view/${d._id}`)}
                  config={{
                    title: "title",
                    desc: 'subtitle',
                    cardLabel: "status",
                    image: 'path.doesnt.exist',
                    metaBlock: [
                      { key: "name", valuePath: "author.name" },
                      { key: "date", valuePath: "dateLastEdited" },
                    ],
                  }}
                />
              ))}
            </Fragment>
          )}
        </WrapperCardGrid>
      </div>
    </Fragment>
  );
};
